import { render } from "./joystickComponent.vue?vue&type=template&id=74d86cd9&scoped=true"
import script from "./joystickComponent.vue?vue&type=script&lang=js"
export * from "./joystickComponent.vue?vue&type=script&lang=js"

import "./joystickComponent.vue?vue&type=style&index=0&id=74d86cd9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d86cd9"]])

export default __exports__